// import { useTheme } from '@emotion/react';
// import { Cancel, CheckCircle, Close } from '@mui/icons-material';
// import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, Grid, IconButton, LinearProgress, Tooltip, Typography } from '@mui/material';
// import React from 'react';
// import { useNavigate, useSearchParams } from 'react-router-dom';

// const ProgressBar = () => {
//     const navigate = useNavigate();
//     const theme = useTheme();
//     const [searchParams, setSearchParams] = useSearchParams()
//     // const currentPathname = window.location.pathname;
//     // console.log(window.location?.includes("?progress=true"),"location")
//     const [openModal, setOpenModal] = React.useState(searchParams.get("progress") || false);
//     const handleClose = () => {
//         const value = searchParams.delete("progress")
//         setSearchParams(value);
//         // setSearchParams({
//         //     progress: false
//         // })
//         setOpenModal(false);

//     };

//     // const dataObject = {
//     //     "statusCode": 200,
//     //     "message": "Data fetched",
//     //     completion: 50,
//     //     data: {

//     //     }
//     //     // "data": {
//     //     //     "total_completion": 50,
//     //     //     "completion": 80,
//     //     //     "total_profile_range": 20,
//     //     //     "profile": 15,
//     //     //     "total_founder_range": 10,
//     //     //     "founder": 9,
//     //     //     "total_pitch_deck_range": 15,
//     //     //     "pitch_deck_url": 15,
//     //     //     "total_elevator_pitch_range": 5,
//     //     //     "elevator_pitch": 0,
//     //     //     "missingFields": {
//     //     //         "profile": ["startup_overview", "website_url", "linkedin_url"],
//     //     //         "founder": ["founder_image"],
//     //     //         "elevatorPitch": ["elevator_pitch"]
//     //     //     }
//     //     // }
//     // };

//     const dataObject = {
//         data: {
//             "Profile": {
//                 "percentage": 50,
//                 "fields": {
//                     "Logo": false,
//                     "Legal Entity Name": false,
//                     "Formation Date": false,
//                     "Stage": false,
//                     "Sector": false,
//                     "Business Model": false,
//                     "Category": false,
//                     "Problem Solved": false,
//                     "Startup Overview": false,
//                     "Website URL": false,
//                     "Linkedin Page": false
//                 },
//                 "subsection_percentage": 20,
//                 "note": "Essential to match investors"
//             },
//             "Founders": {
//                 "percentage": 10,
//                 "completed": false
//             },
//             "Pitch Deck": {
//                 "percentage": 15,
//                 "completed": false
//             },
//             "Elevator Pitch Video": {
//                 "percentage": 5,
//                 "completed": false
//             },
//             "Funding Tab": {
//                 "percentage": 10,
//                 "fields": {
//                     "Name & Type": false,
//                     "Round Name, Type, Security": false,
//                     "Round Size & Valuation": false,
//                     "Round Size, Valuation Floor, Term Sheet": false,
//                     "Fund Utilization": false,
//                     "Highlights, Metrics Name": false,
//                     "Current Traction": false,
//                     "Exit Strategy": false
//                 }
//             },
//             "Documents Tab": {
//                 "percentage": 20,
//                 "fields": {
//                     "Business Plan Document": false
//                 }
//             },
//             "Performance Tab": {
//                 "percentage": 20,
//                 "completed": false
//             },
//             "Total": {
//                 "percentage": 100,
//                 "completed": false
//             }
//         },
//         completion: 50
//     }

//     const { total_completion, completion, missingFields, ...ranges } = dataObject.data;

//     const formattedData = {
//         total_completion,
//         completion,
//         data: Object.keys(ranges)
//             .filter((key) => key.startsWith("total_"))
//             .map((totalKey) => {
//                 const mainKey = totalKey.replace("total_", "").replace("_range", "");
//                 return {
//                     label: mainKey.replace("_", " ").replace(/\b\w/g, (c) => c.toUpperCase()),
//                     total: ranges[totalKey],
//                     completed: ranges[mainKey] || 0,
//                     missingFields: missingFields[mainKey] || [],
//                 };
//             }),
//     };

//     return (
//         <>
//             <Dialog sx={{

//             }} open={openModal} onClose={handleClose} maxWidth="sm" fullScreen>
//                 <DialogTitle sx={{ borderBottom: `1px solid ${theme.palette.customColors.gray300}`, marginBottom: '0.5rem' }}>
//                     <Typography fontWeight={700} fontSize={"1.3rem"} textAlign={'center'}>Profile Completion</Typography>
//                     <IconButton
//                         aria-label="close"
//                         onClick={handleClose}
//                         sx={{ position: "absolute", right: 8, top: 8 }}
//                     >
//                         <Close />
//                     </IconButton>
//                 </DialogTitle>
//                 <DialogContent sx={{
//                     width: '100%',
//                     maxWidth: '900px',
//                     marginInline: 'auto'
//                 }}>
//                     <Grid sx={{
//                         display: 'grid', gap: '0.5rem'
//                         // , placeContent: 'center' 
//                     }}>
//                         <Grid item xs={12}>
//                             {/* <Tooltip title="Profile Completion"> */}
//                             <LinearProgress
//                                 variant='determinate'
//                                 value={formattedData.completion}
//                                 onClick={() => {
//                                     setSearchParams({ progress: true })
//                                     setOpenModal(true);
//                                 }}
//                                 data-progress={`${formattedData.completion}%`}
//                                 sx={{
//                                     height: 20,
//                                     borderRadius: "10px",
//                                     cursor: "pointer",
//                                     display: { xs: 'none', sm: "block" },
//                                     border: "2px solid rgba(0,0,0,0.1)",
//                                     "& .MuiLinearProgress-bar": {
//                                         background: "linear-gradient(to right, #82b5ff, #000000)",
//                                         borderRadius: "20px",
//                                     },
//                                     "::after": {
//                                         content: 'attr(data-progress)',
//                                         position: "absolute",
//                                         top: "50%",
//                                         right: formattedData.completion >= 80 ? "50%" : "1rem",
//                                         // left: "50%",
//                                         transform: "translate(50%, -50%)",
//                                         fontSize: "0.8rem",
//                                         textTransform: 'none',
//                                         color: formattedData.completion >= 80 ? "white" : "black"
//                                     }
//                                 }}
//                             />
//                             {/* </Tooltip> */}
//                         </Grid>
//                         <Box sx={{ backgroundColor: "#f9f9f9", padding: 2, borderRadius: 2 }}>
//                             <Grid container spacing={2}>
//                                 {formattedData.data.map((section, index) => (
//                                     <Grid item xs={6} sm={4} md={3} key={index}>
//                                         <Box display="flex" alignItems="center">
//                                             {section.completed === section.total ? (
//                                                 <CheckCircle sx={{ color: "#000000", mr: 1 }} />
//                                             ) : (
//                                                 <CheckCircle sx={{ color: "lightgray", mr: 1 }} />
//                                             )}
//                                             {/* <Cancel sx={{ color: "lightgray", mr: 1 }} /> */}
//                                             <Typography variant="body2">
//                                                 {section.label}
//                                                 {/* : &nbsp;{section.completed}% */}
//                                             </Typography>
//                                         </Box>
//                                     </Grid>
//                                 ))}
//                             </Grid>
//                         </Box>
//                     </Grid>
//                 </DialogContent>
//             </Dialog>
//             <Box sx={{ minWidth: "5.5rem", width: "100%", maxWidth: "30rem", paddingInline: '0.5rem' }}>
//                 <Tooltip title="Profile Completion">
//                     <LinearProgress
//                         variant='determinate'
//                         value={formattedData.completion}
//                         onClick={() => {
//                             setSearchParams({ progress: true })
//                             setOpenModal(true);
//                         }}
//                         data-progress={`${formattedData.completion}%`}
//                         sx={{
//                             height: 15,
//                             borderRadius: "10px",
//                             cursor: "pointer",
//                             display: { xs: 'none', sm: "block" },
//                             border: "2px solid rgba(0,0,0,0.1)",
//                             "& .MuiLinearProgress-bar": {
//                                 background: "linear-gradient(to right, #82b5ff, #000000)",
//                                 borderRadius: "20px",
//                             },
//                             "::after": {
//                                 content: 'attr(data-progress)',
//                                 position: "absolute",
//                                 top: "50%",
//                                 right: formattedData.completion >= 80 ? "50%" : "1rem",
//                                 // left: "50%",
//                                 transform: "translate(50%, -50%)",
//                                 fontSize: "0.8rem",
//                                 textTransform: 'none',
//                                 color: formattedData.completion >= 80 ? "white" : "black"
//                             }
//                         }}
//                     />
//                 </Tooltip>
//                 {/* <CircularProgress
//                     thickness={4}
//                     variant='determinate'
//                     value={formattedData.completion}
//                     onClick={() => {
//                         setSearchParams({ progress: true })
//                         setOpenModal(true);
//                     }}
//                     sx={{
//                         display: { xs: "block", sm: "none" },
//                         position: 'relative',
//                         cursor: 'pointer',
//                         borderRadius: "50%",
//                         '& .MuiCircularProgress-circle': {
//                             stroke: '#000000',
//                             strokeLinecap: 'round',
//                         }
//                     }}
//                 /> */}
//                 {/* <Box
//                     sx={{
//                         position: 'absolute',
//                         top: '50%',
//                         left: '100%',
//                         transform: 'translate(-20%, -90%)',
//                         display: { xs: "flex", sm: "none" },
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         fontSize: '0.8rem',
//                         color: 'black',
//                         pointerEvents: 'none',
//                     }}
//                 >
//                     {`${formattedData.completion}%`}
//                 </Box> */}
//             </Box>
//         </>
//     );
// };

// export default ProgressBar;


import { useTheme } from '@emotion/react';
import { Cancel, CheckCircle, ChevronRight, Close, RadioButtonUnchecked } from '@mui/icons-material';
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, Grid, IconButton, LinearProgress, List, ListItem, ListItemIcon, ListItemText, Tooltip, Typography } from '@mui/material';
import { GetProfileProgressByStartupID } from 'api/profile';
import Cookies from 'js-cookie';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SET_PROGRESS_DATA } from 'store/actions';
import { formatProgressData, getProgressLabel, getProgressFieldRoute, getProgressFieldName, roundNavigationFields } from 'utilities/index';
import { routeToField } from 'utilities/scrollToField';
import { keyframes } from "@emotion/react";
import CustomPopup from 'ui-components/popups/CustomPopup';
import { trackEvent } from 'utilities/mixpanel';

export const getProgressGradient = (value) => {
    // console.log(value, "value");
    if (value < 50) return "linear-gradient(to right, #ff4d4d, #ff6666)"; // Red
    if (50 <= value && value < 100) return "linear-gradient(to right, #ffcc00, #ffdd55)"; // Yellow
    if (value == 100) return "linear-gradient(to right, #4caf50, #66bb6a)"; // Green
    // return "linear-gradient(to right, #1a33d0, #6aa8ff)"; // Blue
};

const getBorderColor = (value) => {
    // console.log(value, "value");
    if (value < 50) return "#ff4d4d"; // Red
    if (50 <= value && value < 100) return "#ffcc00"; // Yellow
    if (value == 100) return "#4caf50"; // Green
    // return "#1a33d0"; // Blue
};

// Smooth animation for transitions
const progressAnimation = keyframes`
  0% { width: 0; }
  100% { width: 100%; }
`;

// Smooth animation for transitions
const progressCircleAnimation = keyframes`
  0% { opacity: 0; }
  100% { opacity: 100%; }
`;

const ProfileCompletionModal = ({ dataObject, requiredFields = [], isLoading = false, round_id = null }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [openModal, setOpenModal] = React.useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    React.useEffect(() => {
        if (searchParams.get("progress") === "true") {
            setOpenModal(true);
        }
    }, [searchParams]);

    const handleClose = () => {
        searchParams.delete("progress");
        setSearchParams(searchParams);
        setOpenModal(false);
    };

    // Each progress field jumps to the page that owns it, carrying the field
    // name so the destination scrolls it into view. Round fields need the round
    // in session first, and fall back to the rounds list without one.
    const routeFor = (key) =>
        routeToField(getProgressFieldRoute(key), getProgressFieldName(key));

    const goToField = (key) => {
        handleClose();
        if (round_id && roundNavigationFields?.includes(key)) {
            sessionStorage.setItem("round_id", round_id);
            navigate(routeFor(key), { replace: true });
        }
        else {
            if (roundNavigationFields?.includes(key)) {
                navigate("/rounds", { replace: true });
            }
            else {
                navigate(routeFor(key), { replace: true });
            }
        }
    };

    return (
        <CustomPopup handleClose={handleClose} open={openModal} title='Profile Progress' sx={{ maxHeight: { xs: 'calc(100dvh - 8.5rem)', md: 'calc(100dvh - 7.5rem)' }, }} titleSx={{ marginBottom: { xs: 1, md: 4 } }} DialogContentSx={{
            width: "calc(100%)",
            padding: "20px 0px"
        }}>
            <Grid sx={{
                display: 'grid',
                gap: '0.5rem',
                padding: { xs: "1rem", sm: "2rem" },
                paddingTop: "0.5rem !important",
                bgcolor: "#fff",
                borderRadius: "8px",
                border: "1px solid rgb(235 232 251)",
                // , placeContent: 'center' 
            }}>
                <Box sx={{ position: "sticky", top: "-1rem", bgcolor: "white", zIndex: 1, paddingTop: "1rem"}}>
                    <Box style={{ display: "flex", alignItems: 'center', gap: '0.5rem' }}>
                        <LinearProgress
                            variant='determinate'
                            value={dataObject.completion}
                            // onClick={() => {
                            //     setSearchParams({ progress: true })
                            //     setOpenModal(true);
                            // }}
                            // data-progress={`${dataObject.completion}%`}
                            sx={{
                                height: 10,
                                width: "100%",
                                borderRadius: "10px",
                                // cursor: "pointer",
                                // display: { xs: 'none', sm: "block" },
                                border: "1px solid rgb(235 232 251)",
                                backgroundColor: "#e0e0e0", // Light gray background
                                // boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", // Subtle shadow
                                overflow: "hidden",
                                "& .MuiLinearProgress-bar": {
                                    background: getProgressGradient(dataObject.completion),
                                    // transition: "width 0.5s ease-in-out",
                                    // animation: `${progressAnimation} 1s ease-out`,
                                },
                            }}
                        />
                        <Typography variant='bodyTextRegular'
                            // color={getBorderColor(dataObject.completion)} 
                            fontWeight={700}>
                            {dataObject.completion}%
                        </Typography>
                    </Box>
                    <Box padding={1}>
                        <span style={{ fontWeight: 600 }}>Note:</span> Profiles with 80% or higher completion have a greater chance of attracting investor interest.
                    </Box>
                </Box>
                <Box sx={{
                    // backgroundColor: "#f9f9f9",
                    paddingInline: 2, paddingBlock: 1, paddingRight: 0,
                    //  borderRadius: 2,
                    //  border: "1px solid rgb(235 232 251)", 
                    // maxHeight: { xs: "calc(100dvh - 25rem)", sm: "calc(100dvh - 25rem)" },
                }}>
                    {dataObject?.data && (
                        <Box id='profile-progress' sx={{
                            // overflowY: "auto",
                            // maxHeight: "100%",
                            // "&::-webkit-scrollbar": {
                            //     display: { xs: "none", md: "block" },
                            // },
                            // "-ms-overflow-style": "none", // Hide scrollbar in IE and Edge
                            // "scrollbar-width": "none", // Hide scrollbar in Firefox
                        }}>
                            {Object.entries(dataObject?.data).map(([section, value]) => (
                                <Box key={section} sx={{ mb: 0 }}>
                                    {/* <Typography variant="subtitle1" fontWeight="bold"> */}
                                    {/* {value?.fields ? "" : value?.percentage ? (
                                            <CheckCircle color="success" />
                                        ) : (
                                            <CheckCircle color="disabled" />
                                        )} */}

                                    {/* {section.replace(/_/g, " ").toUpperCase()} */}
                                    {/* </Typography> */}
                                    {/* <LinearProgress
                                        variant="determinate"
                                        value={value?.percentage}
                                        sx={{ height: 8, borderRadius: 4, mb: 1 }}
                                    /> */}
                                    {/* <Typography variant="body2" color="textSecondary">
                                        {value?.percentage}% completed
                                    </Typography> */}
                                    {/* {console.log(value, "value")} */}
                                    {value?.fields && <Grid container xs={12}
                                    // sx={{ backgroundColor: "#f9f9f9", padding: 2, borderRadius: 2 }}
                                    >
                                        {Object.keys(value?.fields).map((key) => (
                                            <Grid item xs={12} sm={6} md={4} key={key}>
                                                <ListItem
                                                    disableGutters
                                                    onClick={() => goToField(key)}
                                                    sx={{
                                                        gap: "0.5rem",
                                                        cursor: "pointer",
                                                        borderRadius: "8px",
                                                        paddingInline: "0.5rem",
                                                        transition: "background-color 0.2s ease",
                                                        "&:hover": {
                                                            backgroundColor: "#F2F4F7",
                                                        },
                                                        "&:hover .progress-field-label": {
                                                            color: "#101828",
                                                            textDecoration: "underline",
                                                        },
                                                        "&:hover .progress-field-chevron": {
                                                            opacity: 1,
                                                        },
                                                    }}
                                                >
                                                    <ListItemIcon sx={{ minWidth: 'auto' }}>
                                                        {value?.fields[key] ? (
                                                            <CheckCircle sx={{ color: getBorderColor(100) }} />
                                                        ) : (
                                                            requiredFields?.includes(key) ?
                                                                <CheckCircle sx={{ color: getBorderColor(50) }} /> :
                                                                <CheckCircle color="disabled" />
                                                        )}
                                                    </ListItemIcon>
                                                    {/* {console.log(requiredProgressFields, "red")} */}
                                                    <ListItemText sx={{
                                                        "& > span": {
                                                            width: "fit-content",
                                                            cursor: "pointer"
                                                        }
                                                    }} primary={
                                                        // Kept as a button so the row stays keyboard-reachable; the
                                                        // click itself bubbles up to the ListItem.
                                                        <button className="progress-field-label" style={{ all: "unset", transition: "color 0.2s ease" }}>{key}
                                                            {/* {requiredFields?.includes(key) && <span style={{ color: "red" }}>*</span>} */}
                                                        </button>} />
                                                    {/* Fades in on hover as the "this navigates" cue. Kept mounted at
                                                        zero opacity so the row doesn't reflow under the cursor. */}
                                                    <ChevronRight
                                                        className="progress-field-chevron"
                                                        sx={{
                                                            fontSize: "1.25rem",
                                                            flexShrink: 0,
                                                            color: "#667085",
                                                            opacity: 0,
                                                            transition: "opacity 0.2s ease",
                                                        }}
                                                    />
                                                </ListItem>
                                            </Grid>
                                        ))}
                                    </Grid>}
                                </Box>
                            ))}
                        </Box>
                    )}
                </Box>
                <Box paddingInline={2} paddingBlock={1} display={"grid"} gap={1}>
                    <Box display={"flex"} gap={1} alignItems={"center"}>
                        <Box sx={{
                            width: '1.5rem',
                            height: "1.5rem",
                            aspectRatio: 1,
                            borderRadius: 1,
                            backgroundColor: "#bdbdbd"
                        }}></Box> Incomplete
                    </Box>
                    <Box display={"flex"} gap={1} alignItems={"center"} >
                        <Box
                            sx={{
                                width: '1.5rem',
                                height: "1.5rem",
                                aspectRatio: 1,
                                borderRadius: 1,
                                backgroundColor: getBorderColor(50)
                            }}>
                        </Box>
                        Incomplete & Essential to invite Backrr Investors
                    </Box>
                    <Box display={"flex"} gap={1} alignItems={"center"} >
                        <Box
                            sx={{
                                width: '1.5rem',
                                height: "1.5rem",
                                aspectRatio: 1,
                                borderRadius: 1,
                                backgroundColor: getBorderColor(100)
                            }}>
                        </Box>
                        Completed
                    </Box>
                </Box>
            </Grid>
        </CustomPopup>
    );
};

//   export default ProfileCompletionModal;

const refetchProgressData = ({ dispatch, getProfileProgress, startup_id }) => {
    getProfileProgress({ payload: { startup_id } }).then((data) => {
        if (data?.data?.data) {
            const { dataWithLabelsObject, requiredFieldsLabels, completion, round_id, dataWithLabels } = formatProgressData({ response: data?.data?.data })
            dispatch({
                type: SET_PROGRESS_DATA,
                progressData: { ...dataWithLabelsObject },
                requiredFields: requiredFieldsLabels,
                completionPercentage: completion,
                round_id: round_id,
            });
        }
    })
    return null
}


const ProgressBar = () => {
    const startupDetails = useSelector((state) => state?.startupDetails?.data);
    let progress = useSelector((state) => state?.progress);
    const { mutateAsync: getProfileProgress, isLoading: isLoadingProfileProgress } = GetProfileProgressByStartupID({})
    let [startup_id, setStartupID] = React.useState(Cookies.get("X-ST-ID") || null);
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams()

    const dataObject = {
        data: {
            "Progress Data": {
                fields: {
                    ...progress?.progressData
                }
            }
        },
        completion: progress?.completionPercentage
        // completion: 100
    }

    return (
        <>
            <ProfileCompletionModal dataObject={dataObject} requiredFields={progress?.requiredFields} isLoading={isLoadingProfileProgress} round_id={progress?.round_id} />
            {progress?.progressData && <Box sx={{
                // flex: { xs: 0, sm: 1 },
                // minWidth: { xs: "0rem", sm: '9rem', md: "15rem" },
                width: "100%",
                display: { xs: 'none', sm: dataObject.completion === 100 ? "none" : "flex" },
                minWidth: "5.5rem", width: "100%", maxWidth: "15rem",
                paddingInline: '0.5rem', cursor: "pointer",
                marginRight: '1rem',
                flex: 1
            }} onClick={() => {
                refetchProgressData({ dispatch, getProfileProgress, startup_id })
                searchParams.append("progress", true);
                trackEvent("Clicked Profile Progress Bar", {
                    // message: `User from ${startupDetails?.startup_name} clicked on the profile progress bar to see more details.`,
                    startup_name: startupDetails?.startup_name,
                    progress: dataObject?.completion,
                });
                setSearchParams(searchParams);
            }}>
                <Tooltip title="Click to see more details." style={{ display: "grid", alignItems: 'center', gap: '0.5rem', width: '100%', position: 'relative' }}>
                    <Box>
                        <Typography fontWeight={700}>
                            Profile Progress: {dataObject?.completion}%
                        </Typography>
                    </Box>
                    <LinearProgress
                        variant='determinate'
                        value={dataObject.completion}
                        // data-progress={`${dataObject.completion}%`}
                        sx={{
                            height: 5,
                            width: "100%",
                            borderRadius: "10px",
                            // cursor: "pointer",
                            display: { xs: 'none', sm: "block" },
                            border: "1px solid rgb(235 232 251)",
                            backgroundColor: "#e0e0e0", // Light gray background
                            // boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", // Subtle shadow
                            overflow: "hidden",
                            "& .MuiLinearProgress-bar": {
                                background: getProgressGradient(dataObject.completion),
                                // transition: "width 0.5s ease-in-out",
                                // animation: `${progressAnimation} 1s ease-out`,
                            },
                            // "::after": {
                            //     content: 'attr(data-progress)',
                            //     position: "absolute",
                            //     top: "50%",
                            //     right: dataObject.completion >= 80 ? "50%" : "1rem",
                            //     // left: "50%",
                            //     transform: "translate(50%, -50%)",
                            //     fontSize: "0.8rem",
                            //     textTransform: 'none',
                            //     color: dataObject.completion >= 80 ? "white" : "black"
                            // }
                        }}
                    />
                    {/* <Typography sx={{ display: { xs: 'none', sm: "block" } }} variant='bodyTextRegular' color={"#000000"} fontWeight={900}>
                        {dataObject.completion}%
                    </Typography> */}
                    {/* Circular Percentage Indicator */}
                    {/* <Box
                        sx={{
                            position: "absolute",
                            // top: "-75%",
                            left: `${dataObject.completion + "%"}`,
                            transform: "translateX(-50%)",
                            width: "25px",
                            height: "25px",
                            borderRadius: "50%",
                            background: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "bold",
                            fontSize: "0.8rem",
                            color: "#000",
                            boxShadow: "0px 2px 5px rgba(0,0,0,0.3)",
                            border: `2px solid ${getBorderColor(dataObject.completion)}`,
                            padding: "0.1rem",
                            // transition: "opacity 0.5s ease-in-out",
                            // animation: `${progressCircleAnimation} 1s ease-out`,
                        }}
                    >
                        {dataObject.completion}
                    </Box> */}
                </Tooltip>
            </Box>}
        </>
    );
};

export default ProgressBar;
